/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AveragedCitationCountsResponse } from '../models/AveragedCitationCountsResponse'
import type { CitationAggregateByEnum } from '../models/CitationAggregateByEnum'
import type { CitationByOfficerViolationItem } from '../models/CitationByOfficerViolationItem'
import type { CitationBySpatialResponse } from '../models/CitationBySpatialResponse'
import type { CitationCountResponse } from '../models/CitationCountResponse'
import type { CitationFilterOptionsResponse } from '../models/CitationFilterOptionsResponse'
import type { CitationIssuanceStatisticsResponse } from '../models/CitationIssuanceStatisticsResponse'
import type { CitationMetricEnum } from '../models/CitationMetricEnum'
import type { CitationRevenueStatisticsResponse } from '../models/CitationRevenueStatisticsResponse'
import type { CitationShapeItem } from '../models/CitationShapeItem'
import type { CitationTimePeriodEnum } from '../models/CitationTimePeriodEnum'
import type { Page_CitationLayerItem_ } from '../models/Page_CitationLayerItem_'
import type { Page_CitationOfficerResponse_ } from '../models/Page_CitationOfficerResponse_'
import type { Page_CitationOperatorResponse_ } from '../models/Page_CitationOperatorResponse_'
import type { ParkingDateRangeResponse } from '../models/ParkingDateRangeResponse'
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class ParkingCitationsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Citation Shapes
   * Returns shapes that have aggregated data for the given metric.
   * display_name = shape_name when available, falls back to shape_id (COALESCE).
   * Shape coverage is determined from the aggregate table directly — citations have no
   * pre-mapped location-to-shape table equivalent to parking_insights_locations_to_shapes.
   * @returns CitationShapeItem Successful Response
   * @throws ApiError
   */
  public getCitationShapes({
    regionId,
    shapeLayerUuid,
    metric,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    metric?: CitationMetricEnum | null
  }): CancelablePromise<Array<CitationShapeItem>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking_citations/shapes',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        metric: metric,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Revenue Statistics
   * Total payment revenue and payment count for the primary date range, plus optional compare.
   * Query to the payments table — returns 404 if it does not exist for this layer.
   * Can be called in parallel with GET /statistics/citations.
   * @returns CitationRevenueStatisticsResponse Successful Response
   * @throws ApiError
   */
  public getRevenueStatistics({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    officerBadgeNumbers,
    sourceNames,
    violations,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    startDate: string
    endDate: string
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week to include (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    operators?: Array<string> | null
    /**
     * Filter by officer badge number
     */
    officerBadgeNumbers?: Array<string> | null
    /**
     * Filter by source name
     */
    sourceNames?: Array<string> | null
    /**
     * Filter by violation code
     */
    violations?: Array<string> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<CitationRevenueStatisticsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking_citations/statistics/revenue',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        officer_badge_numbers: officerBadgeNumbers,
        source_names: sourceNames,
        violations: violations,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation Statistics
   * Total unique citation count, total violation amount, and payment compliance for the primary
   * date range, plus optional compare period.
   * Single query to the issuance table — returns 404 if it does not exist for this layer.
   * Can be called in parallel with GET /statistics/revenue.
   * @returns CitationIssuanceStatisticsResponse Successful Response
   * @throws ApiError
   */
  public getCitationStatistics({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    officerBadgeNumbers,
    sourceNames,
    violations,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    startDate: string
    endDate: string
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week to include (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    operators?: Array<string> | null
    /**
     * Filter by officer badge number
     */
    officerBadgeNumbers?: Array<string> | null
    /**
     * Filter by source name
     */
    sourceNames?: Array<string> | null
    /**
     * Filter by violation code
     */
    violations?: Array<string> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<CitationIssuanceStatisticsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking_citations/statistics/citations',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        officer_badge_numbers: officerBadgeNumbers,
        source_names: sourceNames,
        violations: violations,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation Aggregated Counts
   * Time-series chart aggregated by source_name (default) or top-5 violations.
   * metric=revenue → payments table; metric=citations → issuance table.
   * Compare series appended with __compare suffix only when aggregate_by=source.
   * @returns CitationCountResponse Successful Response
   * @throws ApiError
   */
  public getCitationAggregatedCounts({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    metric,
    timePeriodType,
    aggregateBy,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    officerBadgeNumbers,
    sourceNames,
    violations,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    startDate: string
    endDate: string
    /**
     * revenue | citations — selects which metric is aggregated
     */
    metric?: CitationMetricEnum | null
    /**
     * day | week | month | year
     */
    timePeriodType?: CitationTimePeriodEnum | null
    /**
     * source | violation
     */
    aggregateBy?: CitationAggregateByEnum | null
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week to include (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    operators?: Array<string> | null
    /**
     * Filter by officer badge number
     */
    officerBadgeNumbers?: Array<string> | null
    sourceNames?: Array<string> | null
    violations?: Array<string> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    startDateCompare?: string | null
    endDateCompare?: string | null
  }): CancelablePromise<Array<CitationCountResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking_citations/aggregated_counts',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        metric: metric,
        time_period_type: timePeriodType,
        aggregate_by: aggregateBy,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        officer_badge_numbers: officerBadgeNumbers,
        source_names: sourceNames,
        violations: violations,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation Averaged Counts
   * Heatgrid: metric averaged by Day of Week x Hour of Day.
   * @returns AveragedCitationCountsResponse Successful Response
   * @throws ApiError
   */
  public getCitationAveragedCounts({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    metric,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    officerBadgeNumbers,
    sourceNames,
    violations,
    shapeUuids,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * revenue | citations — selects which metric is aggregated
     */
    metric?: CitationMetricEnum | null
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week to include (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    operators?: Array<string> | null
    /**
     * Filter by officer badge number
     */
    officerBadgeNumbers?: Array<string> | null
    /**
     * Filter by source name
     */
    sourceNames?: Array<string> | null
    /**
     * Filter by violation code
     */
    violations?: Array<string> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
  }): CancelablePromise<Array<AveragedCitationCountsResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking_citations/averaged_counts',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        metric: metric,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        officer_badge_numbers: officerBadgeNumbers,
        source_names: sourceNames,
        violations: violations,
        shape_uuids: shapeUuids,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation By Officer Endpoint
   * Top 20 officers by metric, each with top-5 violation breakdown + optional compare total.
   * @returns CitationByOfficerViolationItem Successful Response
   * @throws ApiError
   */
  public getCitationByOfficerEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    sort = 'desc',
    metric,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    officerBadgeNumbers,
    sourceNames,
    violations,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    startDate: string
    endDate: string
    /**
     * desc = top 20 officers, asc = bottom 20 officers
     */
    sort?: 'asc' | 'desc'
    /**
     * revenue | citations — selects which metric is aggregated
     */
    metric?: CitationMetricEnum | null
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week to include (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    operators?: Array<string> | null
    /**
     * Filter by officer badge number
     */
    officerBadgeNumbers?: Array<string> | null
    /**
     * Filter by source name
     */
    sourceNames?: Array<string> | null
    /**
     * Filter by violation code
     */
    violations?: Array<string> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<Array<CitationByOfficerViolationItem>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking_citations/by_officer',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        sort: sort,
        metric: metric,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        officer_badge_numbers: officerBadgeNumbers,
        source_names: sourceNames,
        violations: violations,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation By Shape Endpoint
   * Top or bottom shapes ranked by metric value. Returns compare_count per shape when compare dates are provided.
   * Optionally includes per-violation breakdown (top 5 + Other) when include_violation_breakdown=True.
   * @returns CitationBySpatialResponse Successful Response
   * @throws ApiError
   */
  public getCitationByShapeEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    sort = 'desc',
    limit,
    includeViolationBreakdown = false,
    metric,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    officerBadgeNumbers,
    sourceNames,
    violations,
    shapeUuids,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    startDate: string
    endDate: string
    /**
     * desc = top shapes, asc = bottom shapes
     */
    sort?: 'asc' | 'desc'
    /**
     * Max shapes to return
     */
    limit?: number | null
    /**
     * Include per-violation breakdown (top 5 + Other) for each shape
     */
    includeViolationBreakdown?: boolean
    /**
     * revenue | citations — selects which metric is aggregated
     */
    metric?: CitationMetricEnum | null
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week to include (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    operators?: Array<string> | null
    /**
     * Filter by officer badge number
     */
    officerBadgeNumbers?: Array<string> | null
    /**
     * Filter by source name
     */
    sourceNames?: Array<string> | null
    /**
     * Filter by violation code
     */
    violations?: Array<string> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<Array<CitationBySpatialResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking_citations/by_shape',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        sort: sort,
        limit: limit,
        include_violation_breakdown: includeViolationBreakdown,
        metric: metric,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        officer_badge_numbers: officerBadgeNumbers,
        source_names: sourceNames,
        violations: violations,
        shape_uuids: shapeUuids,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation Legend Values Endpoint
   * Per-shape metric values for the map colour scale.
   * @returns number Successful Response
   * @throws ApiError
   */
  public getCitationLegendValuesEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    metric,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    officerBadgeNumbers,
    sourceNames,
    violations,
    shapeUuids,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * revenue | citations — selects which metric is aggregated
     */
    metric?: CitationMetricEnum | null
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week to include (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    operators?: Array<string> | null
    /**
     * Filter by officer badge number
     */
    officerBadgeNumbers?: Array<string> | null
    /**
     * Filter by source name
     */
    sourceNames?: Array<string> | null
    /**
     * Filter by violation code
     */
    violations?: Array<string> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
  }): CancelablePromise<Array<number>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking_citations/legend_values',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        metric: metric,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        officer_badge_numbers: officerBadgeNumbers,
        source_names: sourceNames,
        violations: violations,
        shape_uuids: shapeUuids,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citations Vector
   * Vector tiles for the citations choropleth map.
   * @returns string Successful Response
   * @throws ApiError
   */
  public getCitationsVector({
    regionId,
    shapeLayerUuid,
    z,
    x,
    y,
    startDate,
    endDate,
    metric,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    officerBadgeNumbers,
    sourceNames,
    violations,
    shapeUuids,
    ifModifiedSince,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    z: number
    x: number
    y: number
    /**
     * Start date (inclusive)
     */
    startDate: string
    /**
     * End date (inclusive)
     */
    endDate: string
    /**
     * revenue | citations — selects which metric is aggregated
     */
    metric?: CitationMetricEnum | null
    /**
     * Hour of day filter start (0-23), inclusive
     */
    startTime?: number | null
    /**
     * Hour of day filter end (0-23), inclusive
     */
    endTime?: number | null
    /**
     * ISO days of week to include (1=Mon … 7=Sun)
     */
    daysOfWeek?: Array<number> | null
    operators?: Array<string> | null
    /**
     * Filter by officer badge number
     */
    officerBadgeNumbers?: Array<string> | null
    /**
     * Filter by source name
     */
    sourceNames?: Array<string> | null
    /**
     * Filter by violation code
     */
    violations?: Array<string> | null
    /**
     * Filter by shape UUID
     */
    shapeUuids?: Array<string> | null
    ifModifiedSince?: string | null
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking_citations/vector/{z}/{x}/{y}',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
        z: z,
        x: x,
        y: y,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        metric: metric,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        officer_badge_numbers: officerBadgeNumbers,
        source_names: sourceNames,
        violations: violations,
        shape_uuids: shapeUuids,
        if_modified_since: ifModifiedSince,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation Filter Options Endpoint
   * Populates Officer badge number, Source, and Violation Code dropdowns.
   * These are all retrieved from same table.
   * @returns CitationFilterOptionsResponse Successful Response
   * @throws ApiError
   */
  public getCitationFilterOptionsEndpoint({
    regionId,
    shapeLayerUuid,
    metric,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    metric: CitationMetricEnum
  }): CancelablePromise<CitationFilterOptionsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking_citations/filter_options',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        metric: metric,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation Date Range Revenue
   * Returns the earliest and latest dates with payment data for a region.
   * Uses the region boundary layer — it has the fewest rows so MIN/MAX is fast.
   * Returns 404 if the payments table does not exist.
   * @returns ParkingDateRangeResponse Successful Response
   * @throws ApiError
   */
  public getCitationDateRangeRevenue({
    regionId,
  }: {
    /**
     * Region identifier
     */
    regionId: string
  }): CancelablePromise<ParkingDateRangeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/parking_citations/date_range/revenue',
      path: {
        region_id: regionId,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation Date Range Citations
   * Returns the earliest and latest dates with issuance data for a region.
   * Uses the region boundary layer — it has the fewest rows so MIN/MAX is fast.
   * Returns 404 if the issuance table does not exist.
   * @returns ParkingDateRangeResponse Successful Response
   * @throws ApiError
   */
  public getCitationDateRangeCitations({
    regionId,
  }: {
    /**
     * Region identifier
     */
    regionId: string
  }): CancelablePromise<ParkingDateRangeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/parking_citations/date_range/citations',
      path: {
        region_id: regionId,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation Operators
   * Returns paginated list of citation enforcement operators for this region.
   * @returns Page_CitationOperatorResponse_ Successful Response
   * @throws ApiError
   */
  public getCitationOperators({
    regionId,
    page = 1,
    size = 50,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    page?: number
    size?: number
  }): CancelablePromise<Page_CitationOperatorResponse_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/parking_citations/operators',
      path: {
        region_id: regionId,
      },
      query: {
        page: page,
        size: size,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation Officers
   * Returns paginated list of citation officers for this region, ordered by badge number.
   * @returns Page_CitationOfficerResponse_ Successful Response
   * @throws ApiError
   */
  public getCitationOfficers({
    regionId,
    page = 1,
    size = 50,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    page?: number
    size?: number
  }): CancelablePromise<Page_CitationOfficerResponse_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/parking_citations/officers',
      path: {
        region_id: regionId,
      },
      query: {
        page: page,
        size: size,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Citation Layers
   * Returns paginated layers that have citation data for the given metric, or for either metric
   * when none is given. Region boundary layer is always first and marked is_default=True.
   * @returns Page_CitationLayerItem_ Successful Response
   * @throws ApiError
   */
  public getCitationLayers({
    regionId,
    page = 1,
    size = 50,
    metric,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    page?: number
    size?: number
    /**
     * revenue | citations; omit for either
     */
    metric?: CitationMetricEnum | null
  }): CancelablePromise<Page_CitationLayerItem_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/parking_citations/layers',
      path: {
        region_id: regionId,
      },
      query: {
        page: page,
        size: size,
        metric: metric,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
}
